import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=0e7668ac&scoped=true&"
import script from "./Language.vue?vue&type=script&lang=ts&"
export * from "./Language.vue?vue&type=script&lang=ts&"
import style0 from "./Language.vue?vue&type=style&index=0&id=0e7668ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7668ac",
  null
  
)

export default component.exports